import React from 'react';
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from 'chart.js';
import { Bar } from 'react-chartjs-2';
import { AXIS_TICKS, GRID_COLOUR, TOOLTIP } from '../dashboard/chartTheme';

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend
);

// const labels = ['January', 'February', 'March', 'April', 'May', 'June', 'July'];

export function MultiVerticalBar({ title, labels, datasets }) {
  const data = {
    labels,
    datasets,
  };
  const options = {
    maintainAspectRatio: false,
    elements: {
      bar: {
        borderWidth: 0,
        borderRadius: 3,
      },
    },
    scales: {
      x: {
        display: true,
        text: 'Percentage Score',
        grid: { display: false },
        ticks: AXIS_TICKS,
      },
      y: {
        beginAtZero: true,
        grid: { color: GRID_COLOUR, drawBorder: false },
        ticks: AXIS_TICKS,
      },
    },
    responsive: true,
    plugins: {
      legend: {
        position: 'bottom',
        labels: { boxWidth: 10, boxHeight: 10, padding: 16, ...AXIS_TICKS },
      },
      tooltip: TOOLTIP,
      title: {
        display: true,
        text: title,
        align: 'start',
        color: '#111827',
        font: { size: 13, weight: '600' },
        padding: { bottom: 12 },
      },
    },
  };

  return <Bar options={options} data={data} />;
}
